import { Col, Modal, Row } from 'antd';
import DaumPostcode from 'react-daum-postcode';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface SelectAddressModalProps {
  visible: boolean;
  selectAddress: (value: any) => void;
  onCancel: () => void;
}

function SelectAddressModal({
  visible,
  selectAddress,
  onCancel,
}: SelectAddressModalProps) {
  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="주소 입력 하기"
        // okText="초대 메일 보내기"
        // cancelText="취소"
        onCancel={onCancel}
        footer={null}
        // onOk={null}
      >
        <>
          <Row justify="center">
            <Col>
              {/* <h3>초대할 직원 이메일 주소를 입력 하세요.</h3> */}
              <DaumPostcode
                onComplete={selectAddress} // 값을 선택할 경우 실행되는 이벤트
                autoClose={false} // 값을 선택할 경우 사용되는 DOM을 제거하여 자동 닫힘 설정
                // defaultQuery={`${myEnterpriseData.address}`} // 팝업을 열때 기본적으로 입력되는 검색어
              />
            </Col>
          </Row>
        </>
      </Modal>
    </StyledDiv>
  );
}

export default SelectAddressModal;
